import React, { useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(SplitText, ScrollTrigger);

function AnimatedHeading({ as: Tag = "h2", className = "", children }) {
  const ref = useRef(null);

  useGSAP(
    () => {
      if (!ref.current) return;
      const split = new SplitText(ref.current, { type: "chars, words" });
      gsap.from(split.chars, {
        duration: 1,
        delay: 0.5,
        x: 40,
        autoAlpha: 0,
        stagger: 0.01,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ref.current,
          start: "top 85%",
        },
      });
      return () => split.revert();
    },
    { scope: ref }
  );

  return (
    <Tag ref={ref} className={`text-anm ${className}`}>
      {children}
    </Tag>
  );
}

export default AnimatedHeading;
